import Main from './Main'

export default [
  { path: '/callcenter', component: Main, name: 'callcenter.main' }
]



// WEBPACK FOOTER //
// ./src/app/callcenter/routes.js